export const CropInformationDefaultDataSetDisease = {
  langMap: [
    {
      langCode: "en",
      name: "",
      summary: "",
      diseaseResistantCultivarAdvice: "",
      interCroppingSuggestionSummary: "",
      tips: "",
      transmission: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      prevention: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      treatment: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      symptomProgression: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
    },
  ],
};

// Pest data model based on user requirements
export const CropInformationDefaultDataSetPest = {
  langMap: [
    {
      langCode: "en",
      name: "",
      summary: "", // pest overview text
      pestCategory: "", // pest category text
      cropFamiliesAffected: "", // crop families affected text
      tips: "", // useful tips text
      interCroppingSuggestionSummary: "", // intercropping suggestions text
      growthStagesForInfection: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      earlySymptoms: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      intermediateSymptoms: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      lateSymptoms: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      beneficialInsectsNaturalPredators: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "NATURAL",
          plantId: "",
        },
      ],
      natureBasedTreatments: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "NATURAL",
          plantId: "",
        },
      ],
      chemicalTreatments: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "CHEMICAL",
          plantId: "",
        },
      ],
      preventionStrategies: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      interCroppingSuggestions: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
    },
  ],
};

export const newDiseaseLangTemplate = {
  name: "",
  summary: "",
  diseaseResistantCultivarAdvice: "",
  interCroppingSuggestionSummary: "",
  tips: "",
  transmission: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  prevention: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  treatment: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  symptomProgression: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
};

export const newPestLangTemplate = {
  name: "",
  summary: "", // pest overview text
  pestCategory: "", // pest category text
  cropFamiliesAffected: "", // crop families affected text
  tips: "", // useful tips text
  interCroppingSuggestionSummary: "", // intercropping suggestions text
  growthStagesForInfection: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  earlySymptoms: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  intermediateSymptoms: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  lateSymptoms: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  beneficialInsectsNaturalPredators: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "NATURAL",
      plantId: "",
    },
  ],
  natureBasedTreatments: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "NATURAL",
      plantId: "",
    },
  ],
  chemicalTreatments: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "CHEMICAL",
      plantId: "",
    },
  ],
  preventionStrategies: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  interCroppingSuggestions: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
};
